import * as Notifications from 'expo-notifications';
import { useChatsContext } from '@/contexts/chats-context';
import { useEffect } from 'react';
import { useVolumePromotionsContext } from '@/contexts/volume-promotions-context';

export const useSyncNotificationBadgeCount = () => {
  const { chatUnreadCountMap } = useChatsContext();
  const { hasNewPromotions } = useVolumePromotionsContext();

  useEffect(() => {
    (async () => {
      // Sum chat unread count
      let count = Object.values(chatUnreadCountMap).reduce((a, b) => a + b, 0);

      // Increment if there are new promotions
      if (hasNewPromotions) {
        count++;
      }

      try {
        await Notifications.setBadgeCountAsync(count, {
          web: {
            favicon: {},
            method: 'Title',
            title: {},
          },
        });
      } catch {
        // fail silently
      }
    })();
  }, [chatUnreadCountMap, hasNewPromotions]);
};
